import { createContext, useContext, useState, useMemo } from 'react';

const HeaderContext = createContext(null);

export const HeaderProvider = ({ children }) => {
    const [headerExtra, setHeaderExtra] = useState(null);

    const value = useMemo(() => ({ headerExtra, setHeaderExtra }), [headerExtra, setHeaderExtra]);

    return (
        <HeaderContext.Provider value={value}>
            {children}
        </HeaderContext.Provider>
    );
};

export const useHeader = () => {
    const context = useContext(HeaderContext);
    if (!context) {
        throw new Error('useHeader must be used within a HeaderProvider');
    }
    return context;
};

export default HeaderContext;
